import React, { useEffect, useState } from "react";
import { Checkbox, Button, Grid, Paper, Table, TableBody, TableCell, TableHead, TableRow, TableSortLabel, } from "@material-ui/core";
import { DeletePopUp, PageLoader, STableLoader, Pagination, EmptyCollection, ExportMenu, FilterComponent, RevisionHistory } from "../../../shared_elements";
import { useSnackbar } from "notistack";
import { trackActivity } from "../../../../utils/mixpanel";
import { globalDeleteService, globalExportService, globalGetService, globalPostService, globalPutService } from "../../../../globalServices";
import { checkApiStatus,checkPermission } from "../../../utils_v2";
import AddIcon from '@material-ui/icons/Add';
import AddEditLlpParts from "../components/AddEditLlpParts";
import LlpPartsList from "../components/LlpPartsList";
import { usePageTitleOffset } from '../../../elements/CollapsibleSideNav';

const LlpPartSObj = {
    module: null,
    description: null,
    sv_interval: null,
    unit_of_measure: null,
    remarks: null,
}

const LlpPartsHeader = ({ handleSelectAll, isSelectAllChecked, createSortHandler, sortInfo }) => {
    return (
        <TableHead>
            <TableRow >
                <TableCell style={{ position: 'sticky', left: 0, backgroundColor: '#B5BEDB', zIndex: 10, }} >{checkPermission('config_data', 'engine_llp_config', 'D')&& <Checkbox checked={isSelectAllChecked} onChange={handleSelectAll} color="primary" size="small" />}Action(s)</TableCell> 
                <TableCell >
                    <TableSortLabel
                        active={sortInfo.sort === 'module' ? true : false}
                        direction={sortInfo.sort === 'module' ? sortInfo.sort_by : 'asc'}
                        onClick={() => createSortHandler('module')}
                    >
                        Module
                    </TableSortLabel>
                </TableCell>
                <TableCell >
                    <TableSortLabel
                        active={sortInfo.sort === 'description' ? true : false}
                        direction={sortInfo.sort === 'description' ? sortInfo.sort_by : 'asc'}
                        onClick={() => createSortHandler('description')}
                    >
                        Description
                    </TableSortLabel>
                </TableCell>
                <TableCell >
                    <TableSortLabel
                        active={sortInfo.sort === 'part_number' ? true : false}
                        direction={sortInfo.sort === 'part_number' ? sortInfo.sort_by : 'asc'}
                        onClick={() => createSortHandler('part_number')}
                    >
                        Part Number
                    </TableSortLabel>
                </TableCell>
                <TableCell >
                    <TableSortLabel
                        active={sortInfo.sort === 'created_by' ? true : false}
                        direction={sortInfo.sort === 'created_by' ? sortInfo.sort_by : 'asc'}
                        onClick={() => createSortHandler('created_by')}
                    >
                        Created By
                    </TableSortLabel>
                </TableCell>
                <TableCell >
                    <TableSortLabel
                        active={sortInfo.sort === 'updated_by' ? true : false}
                        direction={sortInfo.sort === 'updated_by' ? sortInfo.sort_by : 'asc'}
                        onClick={() => createSortHandler('updated_by')}
                    >
                        Last Updated By
                    </TableSortLabel>
                </TableCell>
                <TableCell >
                    <TableSortLabel
                        active={sortInfo.sort === 'remarks' ? true : false}
                        direction={sortInfo.sort === 'remarks' ? sortInfo.sort_by : 'asc'}
                        onClick={() => createSortHandler('remarks')}
                    >
                        Remarks
                    </TableSortLabel>
                </TableCell>
            </TableRow>
        </TableHead>
    )
}

const LlpParts = ({params, isLlp}) => {
    const navTitleOffset = usePageTitleOffset('configDataNavCollapsed');

    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [isLoading, setLoading] = useState(false);
    const [filter, setFilter] = useState({});
    const [pageSelections, setPageSelections] = useState({});
    const [currentPage, setCurrentPage] = useState(1);
    const [skeletonLoader, setSkeletonLoader] = useState(false);
    const [sortInfo, setSortInfo] = useState({ sort: '', sort_by: '' });
    const [bulkDelete, setBulkDelete] = useState({ modal: false, data: null })
    const [bulkRevert, setBulkRevert] = useState({ modal: false, data: null })
    const [addEditLlpParts, setAddEditLlpParts] = useState({ modal: false, data: null });
    const [deleteLlpParts, setDeleteLlpParts] = useState({ modal: false, data: null });
    const [revertLlpParts, setRevertLlpParts] = useState({ modal: false, data: null });
    const [llpPartsInfo, setLlpPartsInfo] = useState({ list: [], pagination: {} });
    const [circularLoader, setCircularloader] = useState(false)

    useEffect(() => {
        getLlpParts({ per_page: 50 }, "skeletonLoader");
        trackActivity('Console Management', { page_title: 'Config Data : Engine LLP Part', event_type: 'Page Visited' })
    }, [])


    const getLlpParts = (query = {}, loaderType) => {
        loaderType === 'skeletonLoader' ? setSkeletonLoader(true) : setLoading(true)

        const url =  `config-data/llp/`;

        globalGetService(url, query)
            .then(response => {
                if (checkApiStatus(response)) {
                    setLlpPartsInfo(response.data.data)
					if (query) {
						delete query.page
						delete query.per_page
						delete query.sort
						delete query.sort_by
                        setFilter(query)
					}
                }
                loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false)
            })
    }

    const onDelete = () => {
        setLoading(true);
        const ids = !deleteLlpParts.data ? Object.values(pageSelections).flat().filter(id => {
            const item = llpPartsInfo.list.find(item => item.id === id);
            return item && !item.deleted_at;
        }) : deleteLlpParts.data.id

        globalDeleteService(`config-data/llp/bulk-delete/`, { ids })
            .then(response => {
                if (checkApiStatus(response)) {
                    setDeleteLlpParts({ modal: false, data: null });
                    getLlpParts({ ...filter, page: llpPartsInfo?.pagination?.page, per_page: llpPartsInfo?.pagination?.per_page }, 'pageLoader')
                    setLoading(false);
                    setPageSelections({});
                    setBulkDelete({ modal: false, data: null })
                    enqueueSnackbar(response?.data?.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                    trackActivity('Console Management', {
                        page_title: 'Config Data : Engine LLP Part',
                        event_type: `Item Deleted`,
                        event_desc: 'LLP Part Deleted Successfully',
                        success_msg: response?.data?.message,
                        deleted_id: ids
                    });
                } else {
                    setDeleteLlpParts({ modal: false, data: null });
                    setLoading(false);
                    setPageSelections({});
                    setBulkDelete({ modal: false, data: null })
                    enqueueSnackbar(response?.data?.message, { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                    trackActivity('Console Management', {
                        page_title: 'Config Data : Engine LLP Part',
                        event_type: `Item Deleted`,
                        event_desc: 'LLP Part Deletion Failed',
                        error_msg: response?.data?.message,
                        item_id: ids
                    });
                }
            });
    };

    const onRevert = () => {
        setLoading(true);
        const ids = !revertLlpParts.data ? Object.values(pageSelections).flat().filter(id => {
            const item = llpPartsInfo.list.find(item => item.id === id);
            return item && item.deleted_at;
        }) : revertLlpParts.data;

        globalPutService(`config-data/llp/restore/`, { ids })
            .then(response => {
                if (checkApiStatus(response)) {
                    setRevertLlpParts({ modal: false, data: null });
                    getLlpParts({ ...filter, page: llpPartsInfo?.pagination?.page, per_page: llpPartsInfo?.pagination?.per_page }, 'pageLoader');
                    setCurrentPage({});
                    setLoading(false);
                    setPageSelections({});
                    setBulkRevert({ modal: false, data: null })
                    enqueueSnackbar(response?.data?.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                    trackActivity('Console Management', {
                        page_title: 'Config Data : Engine LLP Part',
                        event_type: `Item Reverted`,
                        event_desc: 'LLP Part Reverted Successfully',
                        success_msg: response?.data?.message,
                        reverted_id: ids
                    });
                } else {
                    setRevertLlpParts({ modal: false, data: null });
                    setLoading(false);
                    setPageSelections({});
                    setBulkRevert({ modal: false, data: null })
                    enqueueSnackbar(response?.data?.message, { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                    trackActivity('Console Management', {
                        page_title: 'Config Data : Engine LLP Part',
                        event_type: `Item Reverted`,
                        event_desc: 'LLP Part Reversion Failed',
                        error_msg: response?.data?.message,
                        item_id: ids
                    });
                }
            });
    };

    const toggleBulkOps = (item, checked, currentPage) => {
        setPageSelections(prevSelections => {
            const updatedSelections = { ...prevSelections };
            if (checked) {
                updatedSelections[currentPage] = updatedSelections[currentPage] || [];
                updatedSelections[currentPage].push(item?.id);
            } else {
                updatedSelections[currentPage] = updatedSelections[currentPage]?.filter(id => id !== item?.id);
            }
            return updatedSelections;
        });
    };

    const handleSelectAll = (event, currentPage) => {
        if (event?.target.checked) {
            const allIds = llpPartsInfo?.list.map(item => item.id);
            setPageSelections(prevSelections => ({ ...prevSelections, [currentPage]: allIds }));
        } else {
            setPageSelections(prevSelections => ({ ...prevSelections, [currentPage]: [] }));
        }
    };

    const getFilteredSelectionCounts = () => {
        let deleteCount = 0;
        let revertCount = 0;

        if (pageSelections[currentPage]?.length) {
            pageSelections[currentPage].forEach(id => {
                const selectedItem = llpPartsInfo?.list?.find(item => item?.id === id);
                if (selectedItem) {
                    if (selectedItem?.deleted_at) {
                        revertCount++;
                    } else {
                        deleteCount++;
                    }
                }
            });
        }
        return { deleteCount, revertCount };
    };

    const { deleteCount, revertCount } = getFilteredSelectionCounts();

    const createSortHandler = (key) => {
        let sortQuery = { sort: key };
        if (sortInfo.sort === key) {
            sortQuery = { ...sortQuery, sort_by: sortInfo.sort_by === 'asc' ? 'desc' : 'asc' }
        } else {
            sortQuery = { ...sortQuery, sort_by: 'asc' }
        }
        setSortInfo(sortQuery)
        getLlpParts({ ...filter, ...sortQuery, page: 1, per_page: llpPartsInfo?.pagination?.per_page || 20 }, 'pageLoader');
    }

    const isSelectAllChecked = llpPartsInfo?.list?.length > 0 && pageSelections[currentPage]?.length === llpPartsInfo?.list?.length;

    const getConfirmColor = () => {
        if (revertLlpParts?.modal || bulkRevert?.modal) return "primary";
        if (deleteLlpParts?.modal || bulkDelete?.modal) return "secondary";
        return "";
    };

    const getConfirmText = () => {
        if (revertLlpParts?.modal || bulkRevert?.modal) return "Revert";
        if (deleteLlpParts?.modal || bulkDelete?.modal) return "DELETE";
        return "";
    };

    const getModal = () => {
        if (revertLlpParts?.modal) return revertLlpParts.modal;
        if (deleteLlpParts?.modal) return deleteLlpParts.modal;
        if (bulkDelete?.modal) return bulkDelete.modal;
        if (bulkRevert?.modal) return bulkRevert.modal;
        return null;
    };

    const getTitle = () => {
        if (revertLlpParts?.modal) return "Revert LLP Part ";
        if (deleteLlpParts?.modal) return "Delete LLP Part";
        if (bulkDelete?.modal) return `Delete LLP Part (${deleteCount})`;
        if (bulkRevert?.modal) return `Revert LLP Part (${revertCount})`;
        return "";
    };

    const getContent = () => {
        if (revertLlpParts?.modal || bulkRevert?.modal)
            return "Are you sure, you want to Revert?";
        if (deleteLlpParts?.modal || bulkDelete?.modal)
            return "Are you sure, you want to Delete?";
        return "";
    };

    const toggleModalFn = () => {
        if (revertLlpParts?.modal) {
            setRevertLlpParts({ modal: false, data: null });
        } else if (deleteLlpParts?.modal) {
            setDeleteLlpParts({ modal: false, data: null });
        } else if (bulkDelete?.modal) {
            setBulkDelete({ modal: false, data: null });
        } else {
            setBulkRevert({ modal: false, data: null });
        }
    };

    const getDeleteRecordFn = () => {
        if (revertLlpParts?.modal || bulkRevert?.modal) return onRevert;
        if (deleteLlpParts?.modal || bulkDelete?.modal) return onDelete;
        return null;
    };

    const filterOption = (
		{
			'module_name': {
				'inputType': 'text',
				'title': 'Module',
			},
            'description_name': {
				'inputType': 'text',
				'title': 'Description',
			},
            'part_number': {
				'inputType': 'text',
				'title': 'Part Number',
			},
		})

    return (
        <>
            {skeletonLoader ? <STableLoader count={6} /> :
                <div style={{ paddingTop: "10px" }}>
                    <Paper elevation={0} className="console-paper" style={{ padding: '5px 10px', marginBottom: "2px" }}>
                        <Grid container spacing={1} alignItems="center">
                            <Grid item md={7}>
                                <FilterComponent
                                    filter={filter}
                                    filterMenu={filterOption}
                                    getResponseBack={(applyFilter) => { getLlpParts({ ...applyFilter, page: 1, per_page: llpPartsInfo?.pagination?.per_page || 10 }, 'pageLoader') }}
                                />
                            </Grid>
                            <Grid item md={5}>
                                 <ul className='list-inline flex-centered' style={{ float: 'right' }}>
                                    {revertCount > 0 && (
                                        <li className='list-inline-item'>
                                            <Button onClick={() => { setBulkRevert({ modal: true, data: null }); trackActivity('Console Management', { page_title: 'Config Data : Engine LLP Part', item_type: 'Bulk Revert', event_type: 'Modal Clicked', event_desc: `Clicked to open Bulk Revert Modal from LLP Part` }) }} color="primary" size='small' variant="outlined">
                                                Revert ({revertCount})
                                            </Button>
                                        </li>
                                    )}
                                    {deleteCount > 0 && (
                                        <li className='list-inline-item'>
                                            <Button onClick={() => { setBulkDelete({ modal: true, data: null }); trackActivity('Console Management', { page_title: 'Config Data : Engine LLP Part', item_type: 'Bulk Delete', event_type: 'Modal Clicked', event_desc: `Clicked to open Bulk Delete Modal from LLP Part` }) }} color="secondary" size='small' variant="contained">
                                                Delete ({deleteCount})
                                            </Button>
                                        </li>
                                    )}
                                    {!isLlp && checkPermission('config_data', 'engine_llp_config', 'C')  ? <li className='list-inline-item'>
                                        <Button onClick={() => {setAddEditLlpParts({ modal: true, data: LlpPartSObj, type: 'add' }); trackActivity('Console Management', { page_title: 'Config Data : Engine LLP Part', item_type: 'Add', event_type: 'Modal Clicked', event_desc: `Clicked to open Add LLP Modal from LLP Part` }) }} color="primary" size='small' variant="contained"><AddIcon style={{ fontSize: '1.15rem' }} />ADD</Button>
                                    </li> : null }
                                    {!isLlp ?
                                        <li className='list-inline-item' style={{ cursor: 'pointer' }}>
                                            <RevisionHistory isExp={false} buttonType={true} url={`audit/config-data/cdllp/`} queryParams={{ action: '0,1,2' }} />
                                        </li> : null}
                                </ul>
                            </Grid>
                        </Grid>
                    </Paper>
                    <Paper square>
                     <div style={{ height: isLlp ? `${(window.innerHeight - 550) - navTitleOffset}px` : `${(window.innerHeight - ( llpPartsInfo?.list?.length ? 250 : 200)) - navTitleOffset}px`, overflow: 'auto' }}>
                        <Table className="mui-table-format" stickyHeader>
                            <LlpPartsHeader isSelectAllChecked={isSelectAllChecked} handleSelectAll={(e) => handleSelectAll(e, currentPage)} createSortHandler={createSortHandler} sortInfo={sortInfo} />
                            <TableBody>
                                {llpPartsInfo?.list?.length > 0 && llpPartsInfo?.list?.map((item, index) =>
                                    <LlpPartsList
                                        isLlp = {isLlp}
                                        item={item}
                                        index={index}
                                        onDelete={setDeleteLlpParts}
                                        onRevert={setRevertLlpParts}
                                        onEditFn={() => setAddEditLlpParts({ modal: true, data: item, type: 'edit' })}
                                        onViewFn={() => setAddEditLlpParts({ modal: true, data: item, type: 'view' })}
                                        toggleBulkOps={(item, checked) => toggleBulkOps(item, checked, currentPage)}
                                        bulkIds={pageSelections[currentPage] || []}
                                    />
                                )}
                            </TableBody>
                        </Table>
                        {!llpPartsInfo?.list?.length ? <div style={{ textAlign: 'center' }}><EmptyCollection title='No records found' /></div> : null}
                        </div>
                    </Paper>
                    <Paper square>
                        <Pagination
                            pagination={llpPartsInfo?.pagination}
                            onChangePage={(event, newPage) => { getLlpParts({ ...filter, page: newPage + 1, per_page: llpPartsInfo.pagination?.per_page, sort_by: sortInfo?.sort_by, sort: sortInfo?.sort }, 'pageLoader'); setCurrentPage(newPage + 1) }}
                            onChangeRowsPerPage={(event) => getLlpParts({ ...filter, page: 1, per_page: event.target.value, sort_by: sortInfo?.sort_by, sort: sortInfo?.sort }, 'pageLoader')}
                        />
                    </Paper>
                </div>}
            {addEditLlpParts.modal ?
                <AddEditLlpParts
                    addEditLlpParts={addEditLlpParts}
                    llpPartsInfo={llpPartsInfo}
                    toggleModalFn={() => setAddEditLlpParts({ modal: false, LlpPartSObj: [] })}
                    getResponseBack={() => getLlpParts({ ...filter, page: llpPartsInfo?.pagination?.page, per_page: llpPartsInfo?.pagination?.per_page }, 'pageLoader')}
                    modeType={addEditLlpParts?.type}
                /> : null
            }
            <DeletePopUp
                confirmColor={getConfirmColor()}
                confirmText={getConfirmText()}
                modal={getModal()}
                title={getTitle()}
                content={getContent()}
                toggleModalFn={toggleModalFn}
                deleteRecordFn={getDeleteRecordFn()}
                circularloader={circularLoader}
            />
            {isLoading ? <PageLoader /> : null}
        </>
    )

}

export default LlpParts